import { Directive, ElementRef, Input, OnChanges, OnInit, NgModule } from '@angular/core';
declare let $: any;

@Directive({ selector: '[tooltips]' })
export class Tooltips implements OnInit {
    @Input() title: string;

    constructor(private elementRef: ElementRef) {

    }

    setTooltip() {
        $(this.elementRef.nativeElement).tooltip();
    }

    ngOnInit() {
        setTimeout(()=>{
            if (this.title && this.title !== '') {
                this.elementRef.nativeElement.title = this.title;
                this.setTooltip();
            } else {
                this.setTooltip();
            }
            
        });
    }
}


    
@NgModule({
    declarations: [Tooltips],
    imports: [],
    exports:[Tooltips]
})
export class TooltipsModule {

  
}